/*
  Builds the policy page's contents rail from the headings in the policy body.

  WHY AT RUNTIME. Policy prose is authored in Settings > Policies and arrives as
  a blob of HTML. Liquid cannot parse it, so the rail cannot be built server-side
  without asking every store to maintain a duplicate list of its own headings by
  hand - per store, per policy, forever. Reading the DOM gets it right everywhere
  for free, and a store that restructures its policies gets a correct rail with
  no theme change.

  WHEN THERE ARE NO HEADINGS the rail is not faked and not left half-drawn: the
  label and list stay hidden and the help card sits alone. Checked on Zola
  2026-08-13, that is every policy on the store today - Shopify's boilerplate
  uses <strong> as pseudo-headings, which are deliberately NOT promoted here.
  Promoting them would invent structure the author did not write.
*/
(function () {
  'use strict';

  function slug(text, taken) {
    var base =
      text
        .toLowerCase()
        .replace(/[^\w\s-]/g, '')
        .trim()
        .replace(/\s+/g, '-')
        .slice(0, 60) || 'section';
    var id = base;
    var n = 2;
    while (taken[id]) {
      id = base + '-' + n++;
    }
    taken[id] = true;
    return id;
  }

  function build() {
    var body = document.querySelector('[data-policy-body]');
    var toc = document.querySelector('[data-policy-toc]');
    var label = document.querySelector('[data-policy-toc-label]');
    if (!body || !toc) return;

    /* CLEARED FIRST, and hidden again, because this now runs more than once.
       tt-policy-swap.js replaces the body in place when the visitor moves
       between policies, so an append-only build would stack the new policy's
       headings under the old one's - and a policy with no headings at all would
       keep showing the previous page's rail, pointing at anchors that are no
       longer in the document. */
    toc.textContent = '';
    toc.hidden = true;
    if (label) label.hidden = true;

    var headings = body.querySelectorAll('h2, h3');
    if (!headings.length) return;

    var taken = {};
    var frag = document.createDocumentFragment();

    Array.prototype.forEach.call(headings, function (h) {
      var text = (h.textContent || '').trim();
      if (!text) return;
      if (!h.id) h.id = slug(text, taken);
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = text;
      frag.appendChild(a);
    });

    if (!frag.childNodes.length) return;

    toc.appendChild(frag);
    toc.hidden = false;
    if (label) label.hidden = false;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }

  /* The body is swapped rather than reloaded when the policy nav is used. */
  document.addEventListener('tt:policy:body-changed', build);
})();
